var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ModalLayout',{attrs:{"title":_vm.title,"mStyle":_vm.mStyle,"noHeader":_vm.noHeader,"noFooter":_vm.noFooter},on:{"close":_vm.onCloseModal}},[_c('iframe',{ref:"contentFrame",attrs:{"src":_vm.src}})])
}
var staticRenderFns = []

export { render, staticRenderFns }